module.exports = __webpack_public_path__ + "static/media/35_tn.fd08c33a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/35_tn.jpg
// module id = 671
// module chunks = 0